export default __webpack_public_path__ + "static/media/UB_logotyp_2rader_gra_RGB.22e0205b.png";